const GroupTypes = {
  Pharmacy: "fd68bc58-8cf3-4b2c-9078-9d7d57f9af30",
  Retail: "ea135bfd-7444-4dcf-b180-2c5972d39577",
  eCommerce: "52630084-2fa3-4f20-8f8b-897fe5aea01f",
  Audiology: "e144d3e3-693a-4783-8e12-246b428f9e76",
  Super: "67ae1e09-00ad-424c-86b7-4079dacf1eda",
};

export default GroupTypes;
